export default __webpack_public_path__ + "static/media/que.76ea0650.svg";